export const expressionMenuGroupStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
};
